<template>
  <div class="ani-modal" :class="{'modal-popup--show': isShow , 'active': isShow}">
    <div class="modal-popup__wrap">
      <div class="modal-popup__body">
        <div class="log-info">
          <div class="log-info__welcom">
            <strong>{{ getUserNm }}</strong>님 안녕하세요.
          </div>
          <dl class="log-info__time">
            <dt style="font-weight: bold">최근 로그인 일시</dt>
            <dd>{{ getUserLoginDate }}</dd>
          </dl>
          <div>
            <router-link to="/mypage" class="btn-login-keep co-purple" @click.native="close">마이페이지</router-link>
            <button type="button" class="btn-login-keep" @click="extendRefresh">로그인연장</button>
          </div>
          <br />
          <dl class="log-info__time">
            <dt style="font-weight: bold">자동 로그아웃까지 남은 시간</dt>
            <dd>{{ getSessionTime }}</dd>
          </dl>
        </div>
      </div>
    </div>
    <ModalAlert ref="ModalAlert" />
  </div>
</template>

<script>
import ModalAlert from "@/components/common/ModalAlert.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    ModalAlert,
  },
  computed: {
    ...mapGetters("userStore", [
      "getUserNm",
      "getUserLoginDate",
      "getSessionTime",
    ]),
  },
  data() {
    return {
      isShow: false,
    };
  },
  methods: {
    toggle() {
      this.isShow = !this.isShow;
    },
    open() {
      this.isShow = true;
    },
    close() {
      this.isShow = false;
    },
    async extendRefresh() {
      try {
        await this.$store.dispatch("userStore/LOGIN_EXTENSION");
      } catch (err) {
        this.$store.dispatch("userStore/LOGOUT_SHOW_FALSE");
        this.$refs.ModalAlert.show({
          content: "로그인 세션 연장에 실패하였습니다.",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>